import { tmp_units_from_settings } from './interface_helpers';
//OLD SCENES
export const setOldOrsInAnd = (_scene) => {
	let oldOr = _scene.if.or; // and array
	delete _scene.if.or;
	//set first or to empty array - it will contains the active time conditions
	//(it's match better to evaluate the time and continue with other conditions)
	_scene.if.and = [{ or: [] }, { or: oldOr }];
	return _scene;
};

// better than nest functions and return too mutch _scene objects
// avoid delete(_scene) > return _scene and setGlobalAndWithOr(_scene) -> return _scene
export const _onDeleteConditions = (_scene) => {
	delete _scene.if.or;
	_scene.if.and = [{ or: [] }];
	return _scene;
};

// ?____END OLD SCENS HANDLERS_____?

export const _findOrIndex = (_scene) => {
	//find "or" position with all elements different from active time interval
	return _scene.if.and.findIndex((el) => el.or !== undefined && !el.or.find((el) => el.indailyint));
};

export const condition_to_character = (id, deviceSettings = undefined) => {
	switch (id) {
		case 'temperature':
		case 'dewpoint':
		case 'trv_target_temperature':
			return tmp_units_from_settings(deviceSettings);
		case 'humidity':
		case 'moisture':
		case 'brightness':
		case 'white_channel':
		case 'battery':
		case 'tilt':
		case 'roller position':
		case 'valve_percent_position':
		case 'analog_input_add_on':
		case 'multi_cover_position':
		case 'blinds_tilt_position':
		case 'multi_cover_blinds_tilt_position':
		case 'chance_precipitation':
		case 'electricLevel':
		case 'percent':
			return '%';
		case 'meter':
		case 'total_current':
		case 'output_home_power':
		case 'solar_input_power':
		case 'outputLimit':
			return 'W';
		case 'adc':
		case 'vol_meter':
		case 'vol_meter_add_on':
			return 'V';
		case 'dist':
		case 'precipitation':
			return 'mm';
		case 'pressure':
			return 'hPa';
		case 'speed':
		case 'gust_speed':
			return 'm/s';
		case 'uv':
			return 'UV';
		case 'direction':
			return '°';
		default:
			return '';
	}
};
